import BaseAdapter from './base-adapter'

import { rudderstackLoader } from '@/plugins/tracking/helpers/rudderstack-loader'

export default class RudderStackAdapter extends BaseAdapter {
  constructor(locator) {
    super(locator)

    this.writeKey = locator.config.rudderStackWriteKey
    this.dataPlaneUrl = locator.config.rudderStackDataPlaneUrl

    this.isInitialized = false
  }

  init() {
    return new Promise((resolve) => {
      if (this.isInitialized) {
        return resolve()
      }

      if (!this.writeKey || !this.dataPlaneUrl) {
        console.warn(
          '[RudderStack] Not initialized yet. Write key or data plane URL is not set'
        )

        return resolve()
      }

      rudderstackLoader(this.writeKey, this.dataPlaneUrl, {
        logLevel: 'ERROR',
        beaconQueueOptions: {
          maxItems: 5,
          flushInterval: 500,
        },
        onLoaded: () => {
          console.warn('RudderStack JavaScript SDK loaded successfully')
        },
      })

      this.rudderAnalytics = window.rudderanalytics || {}

      this.rudderAnalytics.ready(() => {
        this.isInitialized = true
        resolve()
      })
    })
  }

  trackEvent(eventName, payload) {
    if (!this.isInitialized) {
      console.warn(
        '[RudderStack] Not initialized yet. Event not sent:',
        eventName
      )
      return
    }

    this.rudderAnalytics.track(eventName, payload)
  }

  identify(userId, traits = {}) {
    if (!this.isInitialized) {
      console.warn(
        '[RudderStack] Not initialized yet. Identify not sent:',
        userId
      )
      return
    }

    this.rudderAnalytics.identify(userId, traits)
  }

  reset() {
    if (this.isInitialized) {
      this.rudderAnalytics.reset()
    }
  }
}
